import React from "react";
import styles from "./style.module.css";

const ErrorMessage = ({ message, mt, customClass }) => {
  return (
    <div className={`${styles.error_message} ${mt ? styles.mt_20 : ""} ${customClass ? customClass : ""}`}>
      {message}
    </div>
  );
};

export default ErrorMessage;
